import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';


export function getEvents(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Event`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getEventId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Event/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function createEvent(data: any): Promise<AxiosResponse<any, any>> {
  const formData = new FormData();

  for (const key in data) {
      if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
      }
  }

  return axiosInstance.post('Event', formData, {
      headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
      },
  });
}

export function updateEventId(id: string, data: any): Promise<AxiosResponse<any, any>> {
  const formData = new FormData();

  for (const key in data) {
      if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
      }
  }

  return axiosInstance.put(`Event/${id}`, formData, {
      headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
      },
  });
}
export function deleteEventId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.delete(`Event/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}
